import {
  updateValidateDateRequest,
  queryEnquiryInfoListOfRepairFactoryRequest,
  deleteEnquiryInfoRequest,
  cancelEnquiryRequest,
  quotePriceListApiRequest,
  jnquotedetailApiRequest,
  createFormApiRequest,
  buildPriceRequest
} from '@/assets/request/OrderRequest';
import { Message, MessageBox } from 'element-ui';
import { showLoading, hideLoading } from '@/js/loading';
import { DEALER_QUOTE_FOR_STRING_RESULT, QUALITY_FIRST_LETTER_STRING, PART_QUALITY_REMARK_RESULT, QUALITY_RESULT, QUALITY_PRICE_FOR_STRING_RESULT, MANUFACTURER_FOR_STRING_RESULT, IS_IT_IN_STOCK_FOR_STRING_RESULT } from '@/assets/result/part';
import {
  repairFactoryDetailReturnUrlResult,
} from '../../assets/result/InquiryOrder';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
const queryData = () => ({
  basePageVo_pageno: 1,
  basePageVo_pagesize: 10,
  enquiryDTO_endTime: "",
  enquiryDTO_startTime: "",
  gotoPage: "",
  enquiryDTO_searchBah: "",
  enquiryDTO_cxmc: "",
  enquiryDTO_searchEnquiryNo: "",
  orderInfoDTO_orderNo: "",
  enquiryDTO_searchPlateNo: "",
  orderInfoDTO_searchForm: "",
  orderInfoDTO_searchTo: "",
  type: "",
  enquiryDTO_enquiryQuoteStaus: '',
  enquiryDTO_enquiryState: '',
  enquiryDTO_searchLxr: '',
  enquiryDTO_directSupplyFlag: '',
  enquiryDTO_ordertype: null,
  enquiryDTO_searchVin: '',
});
const quoteQueryData = () => ({
  searchEnquiryStatus: 40,
  searchCompanyName: '',
  searchEnquiryNo: '',
  startTime: "",
  endTime: "",
  searchgqStatus: "",
  searchVin: "",
  searchPlateNo: "",
  is_public: null,
  searchBah: "",
  searchCxmc: "",
  delayBz: "",
  gotoPage: "",
  pageno: 1,
  pagesize: 10,
});
/**
 * 设置询价单详情接口的 tipartList里面的信息
 * @param {*} obj 
 * @param {*} options 
 */
function setTiPartListSelected(obj, options = {
  lj_checked: false,
  aps_id: null,
  lj_type: null,
  lj_price: null,
  inStock: null,
  lj_cs: null,
  lj_quote_bz: null,
}) {
  Object.entries(options).forEach(i => Vue.set(obj, i[0], i[1]));
  if (options.lj_checked) {
    Vue.set(obj, 'showWarning', false);
  }
}
function setTqPartListInfo(obj, options = {
  enquiryInfoId: null,
  freight: null,
  invoiceFlag: null,
  invoiceType: null,
  isTip: null,
  state: null,
  taxPoint: null,
  zdyFlag: null,
}) {
  Object.entries(options).forEach(i => Vue.set(obj, i[0], i[1]));
}
function setPartInTqPartListInfo(obj, options = {
  /*{
      fitsFee:0,
      inStock:0,
      isCheck:false,
      isPt:null,
      isXh:null,
      ljCs:null,
      ljId:0,
      ljPrice:0,
      ljQuoteBz:null,
      ljType:null,/!*传字母首拼大写字符串*!/
      pjsGsmc:null,
      pjsId:null,
      pjsLxfs:null,
      pjsLxr:null,
      taxPoint:null,
      zzfp:null,
  }*/
}) {
  const index = obj.findIndex(i => Number(options.ljId) === Number(i.ljId));
  if (index < 0) return;
  Object.entries(options).forEach(i => Vue.set(obj[index], i[0], i[1]));
}
export default {
  state: {
    inquiryOrderDetailPage: {
      isComparePriceDoneButtonShow: false,
      isShowBackComparePriceButton: false,
      inquiryPriceDoneShow: false,
    },
    inquiryBuildPrice: {},
    currentComparePrice: [],
    quoteList: [],
    quoteQueryData: quoteQueryData(),
    list: [],
    init: true,
    pageSum: 1,
    projectNum: 1,
    queryData: queryData(),
    quoteProjectNum: 1,
    insuranceCompanyItems: [],
    quoteDetailData: {},
    enquiryPriceDetail: {},
  },
  mutations: {
    quoteDetailData_lingjianChangeMutation(state, { partIdArr = [] }) {
      partIdArr.forEach(item => {
        // item即 id
      })
      state.quoteDetailData.lingjian = state.quoteDetailData.lingjian.map(i => {
        const data = {
          ...i,
          showError: partIdArr.map(i => Number(i)).includes(Number(i.id)) ? 1 : 0,
        }
        return data
      })
    },
    checkShowWarningMutation(state) {
      state.enquiryPriceDetail.tipartList.forEach(i => {
        if (!Number(i.lj_price)) {
          Vue.set(i, 'showWarning', true);
        }
      })
    },
    clearCurrentPartTypeSelectedMutation(state) {
      state.enquiryPriceDetail.tipartList.forEach(item => {
        Vue.set(item, 'lj_checked', false);
        Vue.set(item, 'aps_id', null);
        Vue.set(item, 'lj_type', null);
        Vue.set(item, 'lj_price', null);
      });
    },
    /**
     * 选择价格后比价
     * @param {*} state 
     * @param {*} param1 
     * @returns 
     */
    selectedPartPriceAfterComparePriceMutation(state, { dealerId, partType, partId, price, inStock, manufacturer, remark }) {
      let bool = false;
      for (let i = 0; i < state.enquiryPriceDetail.tipartList.length; i++) {
        const item = state.enquiryPriceDetail.tipartList[i];
        if (Number(item.aps_id) && Number(item.aps_id) !== dealerId) {
          bool = true;
          setTiPartListSelected(item);
          setPartInTqPartListInfo(state.enquiryPriceDetail.tqpartliststr.enquiryFitsInfoXjwcDTOList, {
            inStock: 0,
            isCheck: false,
            ljCs: null,
            ljId: Number(item.id),
            ljPrice: 0,
            ljQuoteBz: null,
            ljType: null,
            pjsGsmc: null,
            pjsId: null,
            pjsLxfs: null,
            pjsLxr: null,
            taxPoint: null,
            zzfp: null,
            fitsFee: 0,
            /*
            isPt:null,
            isXh:null,*/
          });
          setTqPartListInfo(state.enquiryPriceDetail.tqpartliststr, {
            // freight:null,
            // invoiceFlag:null,
            // invoiceType:null,
            // isTip:null,
            state: null,
            // taxPoint:null,
            // zdyFlag:null,
          });
        }
      }
      if (state.enquiryPriceDetail.tipartList.length === 1) bool = false
      bool && Message.warning('只能选择一个配件商价格！');
      for (let i = 0; i < state.enquiryPriceDetail.tipartList.length; i++) {
        const item = state.enquiryPriceDetail.tipartList[i];
        if (partId !== Number(item.id)) continue;
        /* 如果选中了就取消选中 */
        if (item.lj_checked && Number(dealerId) === Number(item.aps_id) && partType === Number(item.lj_type)) {
          setTiPartListSelected(item);
          setPartInTqPartListInfo(state.enquiryPriceDetail.tqpartliststr.enquiryFitsInfoXjwcDTOList, {
            inStock: 0,
            isCheck: false,
            ljCs: null,
            ljId: Number(item.id),
            ljPrice: 0,
            ljQuoteBz: null,
            ljType: null,
            pjsGsmc: null,
            pjsId: null,
            pjsLxfs: null,
            pjsLxr: null,
            taxPoint: null,
            zzfp: null,
            fitsFee: 0,
            /*
            isPt:null,
            isXh:null,*/
          });
          setTqPartListInfo(state.enquiryPriceDetail.tqpartliststr, {
            // enquiryInfoId:null,
            // freight:null,
            // invoiceFlag:null,
            // invoiceType:null,
            // isTip:null,
            state: null,
            // taxPoint:null,
            // zdyFlag:null,
          });
          break;
        }
        let fitsFee = 0;
        if (JSON.parse(VueCookie.get('userInfo')).logintype != 3) {
          if ([QUALITY_RESULT.ORIGIN_FACTORY_ORIGIN_PACKAGE].includes(Number(partType))) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.ycjfee
          else if ([QUALITY_RESULT.OE, QUALITY_RESULT.OE.ORIGIN_FACTORY_EASY_PACKAGE].includes(Number(partType))) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.ppptfee
          else if ([QUALITY_RESULT.BRAND, QUALITY_RESULT.CAR_DISASSEMBLY_PART].includes(partType)) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.ppjfee
          else if ([QUALITY_RESULT.DEPUTY_FACTORY].includes(Number(partType))) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.syjfee
        }
        const manageFeePrice = price * item.num * (Number(fitsFee) * 0.01)
        const subtotal = manageFeePrice + price * item.num
        setTiPartListSelected(item, {
          lj_checked: true,
          aps_id: dealerId,
          lj_type: partType,
          lj_price: price,
          inStock,
          lj_cs: manufacturer,
          lj_quote_bz: remark,
          manage_fee: fitsFee,
          manageFeePrice,
          subtotal
        });
        setTqPartListInfo(state.enquiryPriceDetail.tqpartliststr, {
          // enquiryInfoId:null,
          // freight:null,
          // invoiceFlag:null,
          // invoiceType:null,
          // isTip:null,
          state: 'xjwc',
          // taxPoint:null,
          // zdyFlag:null,
        });
        const dealerQuoteInfoItem = this.getters.currentComparePriceGetter.find(i => Number(i.pjsId) === dealerId);
        if (!dealerQuoteInfoItem) return Message.warning('未找到当前配件商！');
        setPartInTqPartListInfo(state.enquiryPriceDetail.tqpartliststr.enquiryFitsInfoXjwcDTOList, {
          inStock: item.inStock,
          isCheck: item.lj_checked,
          ljCs: item.lj_cs,
          ljId: Number(item.id),
          ljPrice: Number(item.lj_price),
          ljQuoteBz: item.lj_quote_bz,
          ljType: QUALITY_FIRST_LETTER_STRING[Object.entries(QUALITY_RESULT).find(i => i[1] === item.lj_type)[0]],
          pjsId: Number(item.aps_id),
          taxPoint: item.tax_point,
          zzfp: dealerQuoteInfoItem.zzfp,
          pjsGsmc: dealerQuoteInfoItem.pjsCompanyName,
          pjsLxfs: dealerQuoteInfoItem.lxfs,
          pjsLxr: dealerQuoteInfoItem.lxr,
          fitsFee
          /*
          isPt:null,
          isXh:null,*/
        });
        break;
      }
    },
    currentComparePriceMutation(state, a = { autoSelected: false }) {
      const { enquiryPriceDetailGetter } = this.getters;
      const dealerSelectedListComputed = enquiryPriceDetailGetter && enquiryPriceDetailGetter.tiApsList ? enquiryPriceDetailGetter.tiApsList.filter(i => i.is_open != 1).filter(i => !location.hostname.includes('yecartour') || i.name.includes('亿卡通') && location.hostname.includes('yecartour')) : [];
      const checkedDealer = dealerSelectedListComputed.filter(i => i.checked);
      let arr = [];
      if (checkedDealer.length > 0) {
        const pjsQuotePriceDetailDTOList = this.getters.inquiryBuildPriceGetter.pjsQuotePriceDetailDTOList;
        if (pjsQuotePriceDetailDTOList && pjsQuotePriceDetailDTOList.length) {
          const checkedDealerId = checkedDealer.map(i => Number(i.aps_userid));
          arr = pjsQuotePriceDetailDTOList.filter(i => checkedDealerId.includes(Number(i.pjsId)));
        }
      }
      else {
        const ycjBest = this.getters.inquiryBuildPriceGetter.ycjBest;
        const ppjBest = this.getters.inquiryBuildPriceGetter.ppjBest;
        const syjBest = this.getters.inquiryBuildPriceGetter.syjBest;
        if (ycjBest && ycjBest.ybjLjNum > 0) arr.push(ycjBest);
        if (ppjBest && ppjBest.ppjLjNum > 0 && (!ycjBest || ycjBest.pjsId != ppjBest.pjsId)) arr.push(ppjBest);
        if (syjBest && ycjBest.fcjLjNum > 0 && (!ycjBest || syjBest.pjsId != ycjBest.pjsId) && (!ppjBest && ppjBest.pjsId != syjBest.pjsId)) arr.push(syjBest);
      }
      state.currentComparePrice = arr.map(i => ({
        ...i,
        pjsQuoteLjPriceDetailDTOList: i.pjsQuoteLjPriceDetailDTOList ? i.pjsQuoteLjPriceDetailDTOList.map((pjsQuoteLjPriceDetailDTOListItem, index) => {
          if (a.autoSelected) {
            const partTypeString = Object.entries(QUALITY_FIRST_LETTER_STRING).find(i => i[1] === enquiryPriceDetailGetter.tqPartList.enquiryFitsInfoXjwcDTOList[index].ljType);
            console.log(pjsQuoteLjPriceDetailDTOListItem.enquiryPersonInfoId);
            console.log(enquiryPriceDetailGetter.tqPartList.enquiryFitsInfoXjwcDTOList[index].pjsId);
            if (Number(pjsQuoteLjPriceDetailDTOListItem.enquiryPersonInfoId) === Number(enquiryPriceDetailGetter.tqPartList.enquiryFitsInfoXjwcDTOList[index].pjsId)) {
              const d = {
                dealerId: Number(pjsQuoteLjPriceDetailDTOListItem.enquiryPersonInfoId),
                partType: QUALITY_RESULT[partTypeString[0]],
                partId: Number(pjsQuoteLjPriceDetailDTOListItem.enquiryFitsInfoId),
                price: Number(pjsQuoteLjPriceDetailDTOListItem[DEALER_QUOTE_FOR_STRING_RESULT[partTypeString[0]]]),
              };
              console.log(d);
              this.commit('selectedPartPriceAfterComparePriceMutation', d);
            }
          }
          return {
            ...pjsQuoteLjPriceDetailDTOListItem,
            pjsybjbz: pjsQuoteLjPriceDetailDTOListItem.pjsybjbz == undefined || pjsQuoteLjPriceDetailDTOListItem.pjsybjbz == 'undefined' ? '' : pjsQuoteLjPriceDetailDTOListItem.pjsybjbz,
            pjsybjcs: pjsQuoteLjPriceDetailDTOListItem.pjsybjcs == undefined || pjsQuoteLjPriceDetailDTOListItem.pjsybjcs == null ? '主机厂' : pjsQuoteLjPriceDetailDTOListItem.pjsybjcs,
            pjsxxjbz: pjsQuoteLjPriceDetailDTOListItem.pjsxxjbz == undefined || pjsQuoteLjPriceDetailDTOListItem.pjsxxjbz == 'undefined' ? '' : pjsQuoteLjPriceDetailDTOListItem.pjsxxjbz,
            pjsxxjcs: pjsQuoteLjPriceDetailDTOListItem.pjsxxjcs == undefined || pjsQuoteLjPriceDetailDTOListItem.pjsxxjcs == null ? '简包' : pjsQuoteLjPriceDetailDTOListItem.pjsxxjcs,
            pjsptjBz: i.pjsptjBz ? i.pjsptjBz : '',
            pjsppjBz: i.pjsppjBz ? i.pjsppjBz : '',
            pjsccjBz: i.pjsccjBz ? i.pjsccjBz : '',
            pjsfcjBz: i.pjsfcjBz ? i.pjsfcjBz : '',
            remarks: i.remarks ? i.remarks : '',
          };
        }) : {
          pjsybjbz: '',
          ljType: '',
          pjsybjcs: '',
          pjsxxjbz: '',
          pjsxxjcs: '',
          pjsptjBz: i.pjsptjBz ? i.pjsptjBz : '',
          pjsppjBz: i.pjsppjBz ? i.pjsppjBz : '',
          pjsccjBz: i.pjsccjBz ? i.pjsccjBz : '',
          pjsfcjBz: i.pjsfcjBz ? i.pjsfcjBz : '',
          remarks: i.remarks ? i.remarks : '',
        }
      }));
      this.commit('inquiryOrderDetailPageUpdateMutation', {
        key: 'isComparePriceDoneButtonShow',
        value: a.autoSelected,
      });
    },
    changeManageFeeOfPartInEnquiryMatation(state, { index, value }) {
      Vue.set(state.enquiryPriceDetail.tipartList[index], 'manage_fee', value);
    },
    changePartCheckedInEnquiryPriceDetailMutation(state, { index, boolean }) {
      Vue.set(state.enquiryPriceDetail.tipartList[index], 'lj_checked', boolean);
    },
    inquiryOrderDetailPageUpdateMutation(state, { key, value }) {
      state.inquiryOrderDetailPage[key] = value;
    },
    inquiryBuildPriceUpdateMutation(state, obj) {
      state.inquiryBuildPrice = obj;
    },
    changeDealerChooseMutation(state, { value, index }) {
      Vue.set(state.enquiryPriceDetail.tiapslist[index], 'checked', value);
    },
    updateManageFeeMutation(state, { key = '', value = 0 }) {
      state.enquiryPriceDetail.managefee[key] = Number(value);
      for (let i = 0; i < state.enquiryPriceDetail.tqpartliststr.enquiryFitsInfoXjwcDTOList.length; i++) {
        const item = state.enquiryPriceDetail.tqpartliststr.enquiryFitsInfoXjwcDTOList[i];
        let fitsFee = 0;
        if ([QUALITY_FIRST_LETTER_STRING.ORIGIN_FACTORY_ORIGIN_PACKAGE].includes(item.ljType)) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.ycjfee
        else if ([QUALITY_FIRST_LETTER_STRING.OE, QUALITY_FIRST_LETTER_STRING.ORIGIN_FACTORY_EASY_PACKAGE].includes(item.ljType)) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.ppptfee
        else if ([QUALITY_FIRST_LETTER_STRING.BRAND, QUALITY_FIRST_LETTER_STRING.CAR_DISASSEMBLY_PART].includes(item.ljType)) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.ppjfee
        else if ([QUALITY_FIRST_LETTER_STRING.DEPUTY_FACTORY].includes(item.ljType)) fitsFee = this.getters.enquiryPriceDetailGetter.manageFee.syjfee
        setPartInTqPartListInfo(state.enquiryPriceDetail.tqpartliststr.enquiryFitsInfoXjwcDTOList, {
          fitsFee,
          ljId: item.ljId
        });
      }
    },
    enquiryPriceDetailMutation(state, obj = {}) {
      if (obj.tipartList) obj.tipartList = obj.tipartList.map(i => ({
        ...i,
        showWarning: false,
      }));
      state.enquiryPriceDetail = obj;
    },
    currentPartDeleteOfTheQuotePage(state, index) {
      state.quoteDetailData.lingjian.splice(index, 1);
    },
    addPartMutation(state) {
      const data = {
        isNewAdd: true,
        num: 1,
        part_name: '',
        spare_part_No: '',
      };
      [MANUFACTURER_FOR_STRING_RESULT, QUALITY_PRICE_FOR_STRING_RESULT, PART_QUALITY_REMARK_RESULT, IS_IT_IN_STOCK_FOR_STRING_RESULT].forEach(i => {
        Object.entries(i).forEach(item => {
          data[item[1]] = '';
        });
      });
      if (state.quoteDetailData.lingjian) {
        state.quoteDetailData.lingjian.push(data);
      }
      else {
        Vue.set(state.quoteDetailData, 'lingjian', [data]);
      }
    },
    /**
     * 更改配件的单个品质是否现货
     * @param state 
     * @param isItInStock
     * @param quality
     * @param id
     * @param partIndex
     */
    updateQuoteIsItInStockMutation(state, { isItInStock, quality, id, partIndex }) {
      if (!state.quoteDetailData.lingjian || state.quoteDetailData.lingjian.length - 1 < partIndex) return;
      const result = state.quoteDetailData.lingjian[partIndex];
      const resultString = Object.entries(QUALITY_RESULT).find(item => item[1] === Number(quality));
      Vue.set(result, IS_IT_IN_STOCK_FOR_STRING_RESULT[resultString[0]], Number(isItInStock));
      const { lingjian } = state.quoteDetailData
      if (!lingjian || !lingjian.length) return;
      /* 过滤出可以报价的品质 */
      const canQuoteQuality = lingjian.map(i => {
        const data = {
          part_id: i.id,
        }
        if ('allow_quality_arr' in i && i['allow_quality_arr'].length) {
          data['quote_arr'] = i['allow_quality_arr']
          return data
        }
        if ('need_quality_arr' in i && i['need_quality_arr'].length) {
          data['quote_arr'] = i['need_quality_arr']
          return data
        }
        return data
      });
      /* 如果没有能报的，则返回 */
      if (!canQuoteQuality.some(i => 'quote_arr' in i && ['quote_arr'].length)) return
      /* 过滤出可更改的是否现货的key的名称 */
      const quoteKeyList = canQuoteQuality.map(i => {
        const data = {
          part_id: i.part_id,
        }
        if (i.quote_arr && i.quote_arr.length) {
          data['quote_key'] = i.quote_arr.map(quoteArrItem => {
            return Object.entries(QUALITY_RESULT).filter(QUALITY_RESULT_Item => Number(QUALITY_RESULT_Item[1]) === Number(quoteArrItem)).map(i => i[0])
          }).reduce((total, item) => {
            item.forEach(itemStr => total.push(itemStr))
            return total
          }, [])
        }
        return data
      })
      /* 根据过滤出来的结果换成后端对应的key */
      const backend_quote_keyList = quoteKeyList.map(i => {
        const data = {
          part_id: i.part_id,
          quote_key: i.quote_key,
          backend_quote_key: [],
        }
        if (i.quote_key && i.quote_key.length) {
          data['backend_quote_key'] = i.quote_key.map(quoteKeyItem => IS_IT_IN_STOCK_FOR_STRING_RESULT[quoteKeyItem])
        }
        return data
      })
      /* 过滤出不同品质的是否现货的value */
      const quoteIsStockList = backend_quote_keyList.map(listItem => {
        const data = {
          ...listItem,
          isStockValue: {},
        }
        const lingjianFilter = lingjian.filter(lingjianItem => Number(lingjianItem.id) === Number(listItem.part_id))
        const lingjianItem = lingjianFilter && lingjianFilter.length ? lingjianFilter[0] : null
        data['isStockValue'] = listItem.backend_quote_key.map(i => ([
          i, lingjianItem ? lingjianItem[i] : null,
        ])).reduce((total, item) => {
          total[item[0]] = item[1]
          return total
        }, {})
        return data
      })
      /* 统一格式，放到一个数组里把是否现货的数字 */
      const allStockList = quoteIsStockList.reduce((total, item) => {
        if (Object.keys(item.isStockValue).length) {
          Object.entries(item.isStockValue).forEach(i => total.push(i[1]))
        }
        return total
      }, [])
      if (Number(isItInStock) === 1) { /* =1 代表选择的是现货 */
        /* 判断所有配件所有品质的是否现货是否全部是“是”， 全为是的话，改为整单是，否则改为整单否  */
        this.commit('updateAllStatus', {
          allStatus: allStockList.every(i => Number(i) === 1) ? 0 : 1,
        })
      }
      else {
        const checkAllISItInStockAllFalse = allStockList.every(i => Number(i) !== 1)

        this.commit('updateAllStatus', {
          allStatus: checkAllISItInStockAllFalse ? 1 : 1,
        })
      }
    },
    updateQuoteManufacturerMutation(state, { manufacturer, quality, id, partIndex }) {
      if (!state.quoteDetailData.lingjian || state.quoteDetailData.lingjian.length - 1 < partIndex) return;
      const result = state.quoteDetailData.lingjian[partIndex];
      const resultString = Object.entries(QUALITY_RESULT).find(item => item[1] === Number(quality));
      if (!resultString) return;
      Vue.set(result, MANUFACTURER_FOR_STRING_RESULT[resultString[0]], manufacturer);
    },
    updateQuotePriceMutation(state, { price, quality, id, partIndex }) {
      if (!state.quoteDetailData.lingjian || state.quoteDetailData.lingjian.length - 1 < partIndex) return;
      const result = state.quoteDetailData.lingjian[partIndex];
      if (isNaN(Number(price) >= 0)) return;
      const resultString = Object.entries(QUALITY_RESULT).find(item => item[1] === Number(quality));
      if (!resultString) return;
      Vue.set(result, QUALITY_PRICE_FOR_STRING_RESULT[resultString[0]], price);
    },
    /**
     * 报价页面的整单是否现货
     * @param state
     * @param allStatus 0 是“是”，1 是“否”（“是现货”和“不是现货”同时存在），2是“整单全部不是现货”（现在鑫卡盟没有2这个选项）
     */
    updateAllStatus(state, { allStatus }) {
      if (!state.quoteDetailData.quoteMain) {
        Vue.set(state.quoteDetailData, 'quoteMain', {
          allstatus: Number(allStatus)
        });
      }
      else {
        Vue.set(state.quoteDetailData.quoteMain, 'allstatus', Number(allStatus));
      }
    },
    initSearchContentMutation(state) {
      state.init = true;
      state.queryData = queryData();
    },
    initQuoteSearchContentMutation(state) {
      state.quoteQueryData = quoteQueryData();
    },
    updateQuoteQueryDataMutation(state, obj) {
      Object.entries(obj).forEach(item => {
        if (['searchEnquiryStatus', 'searchgqStatus', 'is_public', 'pageno', 'pagesize'].includes(item[0])) item[1] = Number(item[1]);
        state.quoteQueryData[item[0]] = item[1];
      });
    },
    updateQueryDataMutation(state, obj) {
      Object.entries(obj).forEach(item => state.queryData[item[0]] = item[1]);
    },
    listLoad(state, { list, queryData, pageSum, projectNum, insuranceCompanyItems }) {
      state.list = list;
      state.pageSum = Number(pageSum);
      state.projectNum = Number(projectNum);
      state.insuranceCompanyItems = insuranceCompanyItems;
      Object.entries(queryData).forEach(item => {
        if (['enquiryDTO_enquiryQuoteStaus', 'enquiryDTO_enquiryState', 'enquiryDTO_directSupplyFlag', 'basePageVo_pagesize', 'basePageVo_pageno', 'enquiryDTO_ordertype'].includes(item[0])) item[1] = Number(item[1]);
        state.queryData[item[0]] = item[1];
      });
    },
    updateInitMutation(state, { bool }) {
      state.init = bool;
    },
    updateQuoteDetailDataMutation(state, obj = {}) { state.quoteDetailData = obj; },
    updateQuoteSignMutation(state, { name, mobile }) {
      if (!state.quoteDetailData) {
        Vue.set(state.quoteDetailData, 'quoteSign', { name, mobile });
      }
      else {
        name && Vue.set(state.quoteDetailData.quoteSign, 'name', name);
        mobile && Vue.set(state.quoteDetailData.quoteSign, 'mobile', mobile);
      }
    },
    updateQuoteRemarkMutation(state, { remark }) {
      Vue.set(state.quoteDetailData, 'remark', remark);
    },
    updateFreightMutation(state, { freight }) {
      Vue.set(state.quoteDetailData, 'freight', Number(freight));
    },
    updateQuoteEffectiveDayMutation(state, { quoteEffectiveDay }) {
      if (state.quoteDetailData.quoteMain) {
        Vue.set(state.quoteDetailData.quoteMain, 'quoteEffectiveDay', quoteEffectiveDay);
      }
      else {
        Vue.set(state.quoteDetailData, 'quoteMain', { quoteEffectiveDay });
      }

    },
    updatePartQualityMutation(state, { quality, id, remark, partIndex }) {
      if (!state.quoteDetailData.lingjian || state.quoteDetailData.lingjian.length - 1 < partIndex) return;
      const result = state.quoteDetailData.lingjian[partIndex];
      const resultString = Object.entries(QUALITY_RESULT).find(item => item[1] === Number(quality));
      if (!resultString) return;
      Vue.set(result, PART_QUALITY_REMARK_RESULT[resultString[0]], remark);
    },
    itemPartQuoteUpdateMutation(state, { partIndex, text, key }) {
      if (!state.quoteDetailData.lingjian || state.quoteDetailData.lingjian.length - 1 < partIndex) return;
      const result = state.quoteDetailData.lingjian[partIndex];
      /* 不是更改的价格才用深拷贝刷新视图，因为价格计算小计，配件多了（30多个左右开始）很卡。 */
      if (!Object.entries(QUALITY_PRICE_FOR_STRING_RESULT).map(item => item[1]).includes(key)) {
        Vue.set(result, key, text);
      }
      else {
        result[key] = text;
      }
    },
    /**
     * 更新报价详情接口下的quoteMain里面的字段
     */
    updateQuoteMainMutation(state, obj) {
      if (!state.quoteDetailData.quoteMain) {
        Vue.set(state.quoteDetailData, 'quoteMain', {})
        state.quoteDetailData.quoteMain = {}
      }
      if (toString.call(obj) !== '[object Object]') return;
      Object.entries(obj).forEach(item => {
        Vue.set(state.quoteDetailData.quoteMain, item[0], item[1])
      })
    },
  },
  actions: {
    async buildPriceAction({ commit, getters }, { enquiryInfoId }) {
      let bool = false
      const r = await buildPriceRequest({ enquiryInfoId }).catch(r => {
        const message = '构建价格异常';
        Message.error(message);
        console.trace({
          message, r
        });
        bool = true
      });
      if (r.status !== 200) {
        Message.warning(r.statusText);
        bool = true
      }
      let data = r.data;
      if (['ERROR', 'UNFINISHED'].includes(data)) bool = true;
      if (Number(data.code) !== 200) bool = true;
      data = data.data
      commit('inquiryBuildPriceUpdateMutation', data);
      if (!bool) return
      /* commit('inquiryOrderDetailPageUpdateMutation',{
          key:'isShowBackComparePriceButton',
          value:Number(getters.enquiryPriceDetailGetter.enquiryState)!==102 && JSON.parse(VueCookie.get('userInfo')).logintype==3,
      }); */
      commit('currentComparePriceMutation', {
        autoSelected: Number(getters.enquiryPriceDetailGetter.enquiryState) !== 102,
      });
    },
    async updateValidateDateAction({ dispatch }, { validateDate, enquiryInfoId, nbBxgsId, isnoBxgs }) {
      showLoading();
      const r = await updateValidateDateRequest({ validateDate, enquiryInfoId }).catch(r => {
        const message = '更改有效期异常，请重试';
        Message.error(message);
        console.trace({
          message, r
        });
        hideLoading();
      });
      if (r.status !== 200) {
        Message.warning(r.statusText);
        return hideLoading();
      }
      const { data } = r;
      if (data === 'error') {
        Message.error("系统异常，请联系系统管理员！");
        return hideLoading();
      }
      dispatch('enquiryPriceDetailAction', { enquiryId: enquiryInfoId, nbBxgsId, isnoBxgs });
      hideLoading();
    },
    async enquiryPriceDetailAction({ commit, dispatch, getters }, { enquiryId, nbBxgsId, isnoBxgs }) {
      showLoading();
      const r = await createFormApiRequest({ enquiryId, nbBxgsId, isnoBxgs }).catch(r => {
        const message = '获取询价详情异常';
        Message.error(message);
        console.trace({
          message, r
        });
        commit('deductTab', 'createForm');
        hideLoading();
      });
      if (r.status !== 200) {
        Message.warning(r.statusText);
        commit('deductTab', 'createForm');
        return hideLoading();
      }
      const { data } = r;
      if (Number(data.status) !== 1) {
        Message.warning(data.info);
        commit('deductTab', 'createForm');
        return hideLoading();
      }
      if (data.data.returnUrl) {
        commit('deductTab', 'createForm');
        const repairArr = [
          [
            repairFactoryDetailReturnUrlResult.SECONDS_REPORT,
            () => {
              commit('changeTab', {
                componentName: 'xlcmbDetail',
                params: {
                  id: enquiryId,
                },
              })
            },
          ],
          [
            repairFactoryDetailReturnUrlResult.STAGING,
            () => {
              commit('changeTab', {
                componentName: 'createFormTemporaryStorage',
                params: {
                  id: enquiryId
                }
              });
            },
          ],
          [
            repairFactoryDetailReturnUrlResult.DENY_SEE,
            () => Message.warning('修理厂不可查看此询价单'),
          ],
          [
            repairFactoryDetailReturnUrlResult.NONE_THIS_INQUIRY,
            () => Message.warning('无此询价单'),
          ],
        ]
        const repairResult = repairArr.filter(i => i[0] === Number(data.data.returnUrl))
        repairResult.length && repairResult[0][1]();
        if (Number(data.data.returnUrl) === 601) {
          commit('changeTab', {
            componentName: 'xlcInquiryDetail',
            params: {
              id: enquiryId
            }
          });
        }
        if (Number(data.data.returnUrl) === 602) {
          commit('changeTab', {
            componentName: 'jnmbPrice',
            params: {
              id: enquiryId
            }
          });
        }
        if (Number(data.data.returnUrl) === 603) {
          commit('changeTab', {
            componentName: 'queryenquiryinfolist'
          });
        }
        if (Number(data.data.returnUrl) === 604) {
          commit('changeTab', {
            componentName: 'jnxjPrice'
          });
        }
        return hideLoading();
      }

      if (Number(data.data.enquiryState) == 100) {
        commit('changeTab', {
          componentName: 'createFormTemporaryStorage',
          params: {
            id: enquiryId
          }
        });
        commit('deductTab', 'createForm');
        return hideLoading();
      }
      data.data.tipartList && data.data.tipartList.forEach(item => {
        item.lj_checked = Boolean(item.lj_checked);
        item.manage_fee = Number(item.manage_fee) ? Number(item.manage_fee) : 0;
        item.manageFeePrice = (Number(item.lj_price) ? Number(item.lj_price) : 0) * (item.manage_fee / 100);
        item.subtotal = Number(item.lj_price * item.num + item.manageFeePrice);
      });
      commit('enquiryPriceDetailMutation', data.data);
      commit('inquiryOrderDetailPageUpdateMutation', {
        key: 'inquiryPriceDoneShow',
        value: Number(getters.enquiryPriceDetailGetter.enquiryState) === 101,
      });
      hideLoading();
      dispatch('buildPriceAction', { enquiryInfoId: enquiryId });
      /* if(Number(getters.enquiryPriceDetailGetter.enquiryState)!==102) dispatch('buildPriceAction',{enquiryInfoId:enquiryId});
      else{
          commit('inquiryOrderDetailPageUpdateMutation',{
              key:'isComparePriceDoneButtonShow',
              value:false,
          });
      } */
    },
    /**
     * 报价详情和放弃
     * @param commit
     * @param dispatch
     * @param id
     * @param fqbz
     * @returns {Promise<*>}
     */
    async jnquotedetailApiAction({ commit, dispatch }, { id, fqbz, callback, }) {
      const arr = [];
      arr[0] = id;
      fqbz ? arr[1] = fqbz : null;
      const r = await jnquotedetailApiRequest(...arr).catch(r => {
        const message = '获取报价详情异常';
        Message.error(message);
        console.trace({
          message, r
        });
      });
      if (r.status !== 200) return Message.warning(r.statusText);
      const { data } = r;
      if (data.status != 1) {
        this.state.openedTab.some(i => i === 'jnquotedetail') && commit('deductTab', 'jnquotedetail');
        return Message.warning(fqbz ? '放弃失败' : data.info);
      }
      /* 跳转到用户信息页面， */
      if (data.data.returnUrl == 201) {
        this.state.openedTab.some(i => i === 'jnquotedetail') && commit('deductTab', 'jnquotedetail');
        await MessageBox.alert(data.info, '提醒');
        commit(this.state.openedTab.includes('doUserInfo') ? 'changeTab' : 'addTab', {
          componentName: 'doUserInfo'
        });
      }
      else if (data.data.returnUrl == 205) {
        /* 放弃成功 */
        this.state.openedTab.some(i => i === 'jnquotedetail') && commit('deductTab', 'jnquotedetail');
        await MessageBox.alert(fqbz ? '放弃成功' : data.info, '提醒');
        commit(this.state.openedTab.includes('queryPriceList') ? 'changeTab' : 'addTab', {
          componentName: 'queryPriceList'
        });
      }
      else if ([202, 203, 204].includes(Number(data.data.returnUrl))) {
        if (data.data && data.data.lingjian && toString.call(data.data.lingjian) === '[object Array]') {
          data.data.lingjian = data.data.lingjian.map(item => {
            const d = {
              ...item,
            };
            if (data.data.returnUrl == 202 && item.oldlist) {
              Object.entries(item.oldlist).forEach(item => {
                d[item[0]] = item[1];
              });
            }
            const r = Object.entries(IS_IT_IN_STOCK_FOR_STRING_RESULT).map(i => ([
              [i[1]], item[i[1]] && Number(item[i[1]]) !== 1 ? 2 : 1
            ]));
            r.forEach(item => {
              d[item[0]] = item[1];
            });
            return d;
          });
        }
        if (!data.data.quoteMain) {
          data.data.quoteMain = {};
          [{ key: 'quoteEffectiveDay', value: 15 }, { key: 'allstatus', value: 0 }].forEach(item => {
            data.data.quoteMain[item.key] = item.value;
          });
        }

        data.data.reminderInfo && MessageBox.alert(data.data.reminderInfo, '提醒', {
          confirmButtonText: '确定'
        })
        commit('updateQuoteDetailDataMutation', data.data);
        toString.call(callback) === '[object Function]' && callback({ partList: data.data.lingjian, });
        if (data.data.insInfo) dispatch('partTypeStore/updatePartAction', {
          ins_id: data.data.insInfo.ins_id,
        })
      }
      if (data.data.is_oe_correction) alert(`驾安配提示：${data.data.inquiryinformation.order_remark}，请先进行OE纠错之后再提交报价。`)
    },
    async quotePriceListApiAction(context) {
      const { state, commit, dispatch, } = context
      dispatch('Quote/setInsuranceCompanyList')
      showLoading();
      const dataSend = Object.entries({ ...state.quoteQueryData }).map(i => {
        if (['[object Object]', 'object Array'].includes(toString.call(i[1]))) i[1] = JSON.stringify(i[1]);
        return [
          i[0], i[1]
        ];
      }).reduce((total, item) => { total[item[0]] = item[1]; return total; }, {})
      const ins_ids = context.getters['Quote/QuoteGetter']['ins_ids']
      const r = await quotePriceListApiRequest({
        ...dataSend,
        ins_ids: context.getters['Quote/QuoteGetter']['ins_ids'].slice(1),
      }).catch(r => {
        const message = '获取报价列表异常';
        Message.error(message);
        console.trace({
          message, r
        });
        hideLoading();
      });
      if (r.status !== 200) return hideLoading(), Message.warning(r.statusText);
      const { data } = r;
      if (Number(data.status) !== 1) return hideLoading(), Message.warning(data.info);
      state.quoteList = data.data.projectList;
      state.quoteProjectNum = Number(data.data.projectNum);
      commit('Quote/_setIns_Ids', ins_ids)
      commit('updateQuoteQueryDataMutation', data.data.queryData);
      hideLoading();
    },
    async queryEnquiryInfoListOfRepairFactoryAction({ state, commit }) {
      showLoading();
      let dataParam = {};
      if (state.init) {
        commit('updateInitMutation', { bool: false });
        dataParam = {
          basePageVo_pageno: 1,
          basePageVo_pagesize: 10,
        }
      }
      else dataParam = { ...state.queryData };
      const r = await queryEnquiryInfoListOfRepairFactoryRequest(dataParam).catch(r => {
        const message = '获取询价单异常';
        Message.error(message);
        console.trace({
          message, r
        });
        hideLoading();
      });
      if (r.status !== 200) return hideLoading(), Message.warning(r.statusText);
      const { data } = r;
      if (Number(data.status) !== 1) return hideLoading(), Message.warning(data.info);
      commit('listLoad', {
        list: data.data.projectList,
        queryData: data.data.queryData,
        pageSum: data.data.pageSum,
        projectNum: data.data.projectNum,
        insuranceCompanyItems: data.data.tinsInfo,
      });
      hideLoading();
    },
    async deleteEnquiryInfoAction({ dispatch }, { id = 0 }) {
      const confirm = await MessageBox.confirm('您确定删除当前询价单吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).catch(r => {
        console.trace(r);
      });
      if (confirm !== 'confirm') return;
      if (!id) return Message.warning('询价单编号异常，请重试！');
      showLoading();
      const result = await deleteEnquiryInfoRequest(id).catch(r => {
        const message = '删除异常';
        Message.error(message);
        console.trace({
          message, r
        });
        hideLoading();
      });
      if (result.status !== 200) return hideLoading(), Message.warning(result.statusText);
      const { data } = result;
      if (data == 1) {
        Message.success("该询价单已成功删除！");
        hideLoading();
        dispatch('queryEnquiryInfoListOfRepairFactoryAction');
      } else {
        Message.error('删除失败');
        hideLoading();
      }
    },
    async cancelEnquiryAction({ dispatch }, { enquiryId, enquiryNo }) {
      const confirm = await MessageBox.confirm('您确定隐藏当前询价单吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).catch(r => {
        console.trace(r);
      });
      if (confirm !== 'confirm') return;
      showLoading();
      const r = await cancelEnquiryRequest(enquiryId, enquiryNo).catch(r => {
        const message = '隐藏异常';
        Message.error(message);
        console.trace({
          message, r
        });
        hideLoading();
      });
      if (r.status !== 200) return hideLoading(), Message.warning(r.statusText);
      const { data } = r;
      if (data == 0) {
        Message.success('隐藏成功');
        dispatch('queryEnquiryInfoListOfRepairFactoryAction');
        hideLoading();
      }
      else {
        Message.warning(data);
        hideLoading();
      }
    },
  },
  getters: {
    currentComparePriceGetter: (state, getter) => {
      let dealerId = Array.from(new Set(getter.enquiryPriceDetailGetter.tiPartList.map(i => Number(i.aps_id)).filter(i => i)));
      dealerId = dealerId ? dealerId[0] : 0;
      return state.currentComparePrice.map(i => {
        return {
          ...i,
          originFactoryOriginPackageAllSelected: dealerId === Number(i.pjsId) && i.ybjLjNum <= getter.enquiryPriceDetailGetter.tiPartList.filter(i => i.lj_checked && Number(i.lj_type) === QUALITY_RESULT.ORIGIN_FACTORY_ORIGIN_PACKAGE).length,
          originFactoryEasyPackageAllSelected: dealerId === Number(i.pjsId) && i.xxjLjNum <= getter.enquiryPriceDetailGetter.tiPartList.filter(i => i.lj_checked && Number(i.lj_type) === QUALITY_RESULT.ORIGIN_FACTORY_EASY_PACKAGE).length,
          oePackageAllSelected: dealerId === Number(i.pjsId) && i.ptjLjNum <= getter.enquiryPriceDetailGetter.tiPartList.filter(i => i.lj_checked && Number(i.lj_type) === QUALITY_RESULT.OE).length,
          brandPackageAllSelected: dealerId === Number(i.pjsId) && i.ppjLjNum <= getter.enquiryPriceDetailGetter.tiPartList.filter(i => i.lj_checked && Number(i.lj_type) === QUALITY_RESULT.BRAND).length,
          carDisassemblyPartPackageAllSelected: dealerId === Number(i.pjsId) && i.ccjLjNum <= getter.enquiryPriceDetailGetter.tiPartList.filter(i => i.lj_checked && Number(i.lj_type) === QUALITY_RESULT.CAR_DISASSEMBLY_PART).length,
          deputyFactoryPackageAllSelected: dealerId === Number(i.pjsId) && i.fcjLjNum <= getter.enquiryPriceDetailGetter.tiPartList.filter(i => i.lj_checked && Number(i.lj_type) === QUALITY_RESULT.DEPUTY_FACTORY).length,
        }
      });
    },
    inquiryBuildPriceGetter: state => state.inquiryBuildPrice,
    inquiryOrderDetailPageGetter: state => state.inquiryOrderDetailPage,
    enquiryPriceDetailGetter: state => {
      const { enquiryPriceDetail } = state;
      return {
        isEnquiryPriceDone: enquiryPriceDetail.xjwc_pic != null && Boolean(enquiryPriceDetail.xjwc_pic.length),
        picList: enquiryPriceDetail.piclist ? enquiryPriceDetail.piclist.map(i => ({
          ...i,
          // img_path: enquiryPriceDetail.ossPrefix + '/userimg/' + i.img_path,
        })) : [],
        tqsInfo: enquiryPriceDetail.tqsinfo ? enquiryPriceDetail.tqsinfo : {},
        defaultProvinceName: enquiryPriceDetail.dfaultpname ? enquiryPriceDetail.dfaultpname : '',
        curUser: enquiryPriceDetail.curUser ? enquiryPriceDetail.curUser : {},
        repairFactoryName: enquiryPriceDetail.rpdname ? enquiryPriceDetail.rpdname : '',
        surveyor: enquiryPriceDetail.surveyor ? enquiryPriceDetail.surveyor : {},
        fFrom: Number(state.enquiryPriceDetail.ffrom),
        tiApsList: state.enquiryPriceDetail.tiapslist,
        manageFee: state.enquiryPriceDetail.managefee,
        tiPartList: state.enquiryPriceDetail.tipartList ? state.enquiryPriceDetail.tipartList : [],
        fId: state.enquiryPriceDetail.fId,
        enquiryId: state.enquiryPriceDetail.enquiryId,
        enquiryState: state.enquiryPriceDetail.enquiryState,
        partDirectSupplyInfo: state.enquiryPriceDetail.pjzg,
        loginUser: state.enquiryPriceDetail.loginUser ? state.enquiryPriceDetail.loginUser : {},
        pushFlag: state.enquiryPriceDetail.pushFlag,
        tqPartList: state.enquiryPriceDetail.tqpartliststr,
        pjzgInfo: state.enquiryPriceDetail.pjzgInfo,
        rpd_mobile: enquiryPriceDetail.rpd_mobile ? enquiryPriceDetail.rpd_mobile : '',
        deliveryInfo: enquiryPriceDetail.deliveryInfo ? enquiryPriceDetail.deliveryInfo : {},
        download_pdf: enquiryPriceDetail.download_pdf,
        orderId: enquiryPriceDetail.orderId,
      }
    },
    getOrderListGetter: state => state,
    getQuoteQueryData: state => state.quoteQueryData,
    dealerGetQuoteInfoGetter: state => ({
      isEnquiryPriceDone: state.quoteDetailData.xjwc_pic != null && Boolean(state.quoteDetailData.xjwc_pic.length),
      inquiryInformation: state.quoteDetailData && state.quoteDetailData.inquiryinformation ? state.quoteDetailData.inquiryinformation : {},
      userUser: state.quoteDetailData.useruser ? state.quoteDetailData.useruser : {},
      quoteMain: state.quoteDetailData.quoteMain,
      inquiryCount: state.quoteDetailData.inquiryCount && state.quoteDetailData.inquiryCount.inquiryCount ? Number(state.quoteDetailData.inquiryCount.inquiryCount) : 0,
      partList: state.quoteDetailData && state.quoteDetailData.lingjian ? state.quoteDetailData.lingjian.map(i => ({
        ...i,
        need_quality_arr: i.need_quality_arr ? i.need_quality_arr.map(i => Number(i)) : [],
      })) : [],
      returnUrl: state.quoteDetailData.returnUrl,
      addPriceFlag: state.quoteDetailData.addPriceFlag,
      picList: state.quoteDetailData.piclist && toString.call(state.quoteDetailData.piclist) === '[object Array]' ? state.quoteDetailData.piclist.map(i => ({
        ...i,
        // img_path:state.quoteDetailData.ossPrefix+'/userimg/'+i.img_path
      })) : [],
      remark: state.quoteDetailData.remark,
      freight: state.quoteDetailData.freight,
      is_freight: state.quoteDetailData.is_freight,
      // is_freight: true,
      curUser: state.quoteDetailData.curUser ? state.quoteDetailData.curUser : {},
      ds_name: state.quoteDetailData.ds_name ? state.quoteDetailData.ds_name : '',
      ds_mobile: state.quoteDetailData.ds_mobile ? state.quoteDetailData.ds_mobile : '',
      surveyor: state.quoteDetailData.surveyor ? state.quoteDetailData.surveyor : null,
      quoteSign: state.quoteDetailData.quoteSign ? state.quoteDetailData.quoteSign : null,
      hrate: state.quoteDetailData.hrate ? state.quoteDetailData.hrate : {},
      order_info: state.quoteDetailData.order_info,
      quoteDetailData: state.quoteDetailData,
    }),
    /**
   * 询价人是否是人保的保险公司。
   * @param state
   * @param getter
   * @returns 
   */
    isInquiryPersonPeopleInsurance(state, getter) {
      if (!getter.dealerGetQuoteInfoGetter || !getter.dealerGetQuoteInfoGetter.quoteDetailData) return false;
      const { insInfo = null, } = getter.dealerGetQuoteInfoGetter.quoteDetailData
      if (!insInfo) return false;
      return Number(insInfo.ins_id) === 2;
    }
  },
}
